// Handle modal switching between mobile and desktop
document.addEventListener('DOMContentLoaded', function() {
  const modalOpeners = document.querySelectorAll('modal-opener[data-modal-desktop]');
  
  modalOpeners.forEach(opener => {
    const button = opener.querySelector('button[aria-haspopup="dialog"]');
    if (!button) return;
    
    button.addEventListener('click', function(e) {
      const isMobile = window.innerWidth <= 989;
      const mobileModal = opener.getAttribute('data-modal');
      const desktopModal = opener.getAttribute('data-modal-desktop');
      
      // Set the correct modal BEFORE the modal-opener processes the click
      if (isMobile && mobileModal) {
        opener.setAttribute('data-modal', mobileModal);
      } else if (!isMobile && desktopModal) {
        opener.setAttribute('data-modal', desktopModal);
      }
    }, true); // Use capture phase to run before modal-opener's handler
  });
});

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      // ... rest of the code stays exactly the same
      constructor() {
        super();
        this.currentIndex = 0;
        this.totalSlides = 0;
        this.slider = null;
        this.setupNavigation();
      }
      
      isMobile() {
        return window.innerWidth <= 989;
      }
      
      setupNavigation() {
        this.prevBtn = this.querySelector('.product-media-modal__nav--prev');
        this.nextBtn = this.querySelector('.product-media-modal__nav--next');
        
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.isMobile()) {
              this.slideToPrevious();
            }
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.isMobile()) {
              this.slideToNext();
            }
          });
        }
      }
      
      slideToPrevious() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updateSliderPosition();
        }
      }
      
      slideToNext() {
        if (this.currentIndex < this.totalSlides - 1) {
          this.currentIndex++;
          this.updateSliderPosition();
        }
      }
      
      updateSliderPosition() {
        if (!this.slider) return;
        
        const offset = -this.currentIndex * 100;
        this.slider.style.transform = `translateX(${offset}vw)`;
        
        if (this.prevBtn) {
          this.prevBtn.classList.toggle('hidden', this.currentIndex === 0);
        }
        if (this.nextBtn) {
          this.nextBtn.classList.toggle('hidden', this.currentIndex === this.totalSlides - 1);
        }
        
        this.centerActiveImage();
      }
      
      centerActiveImage() {
        setTimeout(() => {
          const activeSlide = this.slider?.children[this.currentIndex];
          if (!activeSlide) return;
          
          const img = activeSlide.querySelector('img, video');
          if (img && img.offsetWidth > window.innerWidth) {
            const scrollPosition = (img.offsetWidth - window.innerWidth) / 2;
            activeSlide.scrollLeft = scrollPosition;
          }
        }, 100);
      }
      
      hide() {
        super.hide();
      }
      
      show(opener) {
        super.show(opener);
        
        if (this.isMobile()) {
          this.initializeSlider(opener);
        } else {
          this.showActiveMedia();
        }
      }
      
      initializeSlider(opener) {
        this.slider = this.querySelector('.product-media-slider');
        const slides = this.querySelectorAll('.product-media-item');
        const content = this.querySelector('.product-media-modal__content');
        this.totalSlides = slides.length;
        
        if (content) {
          content.scrollLeft = 0;
          content.scrollTop = 0;
        }
        
        const clickedMediaId = opener?.getAttribute('data-media-id');
        this.currentIndex = 0;
        
        if (clickedMediaId) {
          slides.forEach((slide, index) => {
            if (slide.getAttribute('data-media-id') === clickedMediaId) {
              this.currentIndex = index;
            }
          });
        }
        
        if (this.slider) {
          this.slider.style.transition = 'none';
          const offset = -this.currentIndex * 100;
          this.slider.style.transform = `translateX(${offset}vw)`;
          
          void this.slider.offsetHeight;
          
          requestAnimationFrame(() => {
            if (this.slider) {
              this.slider.style.transition = 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
            }
          });
        }
        
        if (this.prevBtn) {
          this.prevBtn.classList.toggle('hidden', this.currentIndex === 0);
        }
        if (this.nextBtn) {
          this.nextBtn.classList.toggle('hidden', this.currentIndex === this.totalSlides - 1);
        }
        
        this.showActiveMedia();
      }
      
      showActiveMedia() {
        if (this.isMobile()) {
          const activeSlide = this.slider?.children[this.currentIndex];
          if (!activeSlide) return;
          
          const centerScroll = () => {
            const img = activeSlide.querySelector('img, video');
            
            if (img && img.offsetWidth > 0) {
              const scrollPosition = (img.offsetWidth - window.innerWidth) / 2;
              activeSlide.scrollLeft = scrollPosition;
              return true;
            }
            return false;
          };
          
          let attempts = 0;
          const maxAttempts = 10;
          const tryCenter = () => {
            if (centerScroll() || attempts >= maxAttempts) {
              return;
            }
            attempts++;
            setTimeout(tryCenter, 100);
          };
          
          setTimeout(tryCenter, 50);
        } else {
          // Desktop: use original behavior
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          if (activeMedia) {
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();
            
            const container = this.querySelector('[role="document"]');
            if (container && activeMedia.width) {
              container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
            }
          }
        }
      }
    }
  );
}